// extracted by mini-css-extract-plugin
export default {"container":"whoIsThisCourseFor_container__fMCjK","icon":"whoIsThisCourseFor_icon__ZXpIk","requirements":"whoIsThisCourseFor_requirements__PElQd"};